import React from "react";
import { Box, Paper, Stack, Typography, Container } from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";

type Props = {
  title: string;
  content: string;
  success: boolean;
};

export const Card: React.FC<Props> = ({ title, success, content }) => {
  return (
    <Box
      style={{
        height: "200px",
        display: "flex",
        alignItems: "center",
        width: "100%",
      }}
    >
      <Paper sx={{ width: "100%" }}>
        <Stack
          direction="row"
          sx={{
            mx: "10px",
          }}
        >
          <Container
            sx={{ position: "relative", height: "100px", width: "50%" }}
          >
            <Paper
              elevation={3}
              sx={{
                padding: "30px",
                backgroundColor: `${success ? "#56C568" : "#EB5757"}`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "absolute",
                top: "-40px",
              }}
            >
              {success ? (
                <CheckCircleRoundedIcon
                  fontSize="large"
                  sx={{ color: "white" }}
                />
              ) : (
                <CancelRoundedIcon fontSize="large" sx={{ color: "white" }} />
              )}
            </Paper>
          </Container>

          <Stack
            spacing={2}
            sx={{
              width: "100%",
              display: "flex",
              my: "20px",
            }}
          >
            <Typography
              color={`${success ? "#56C568" : "#EB5757"}`}
              fontWeight="bold"
            >
              {title}
            </Typography>
            <Typography fontSize="12px">{content}</Typography>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
              }}
            ></Box>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
};
